import type { RequestInterface } from '~/common/types';

export class FeatureRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    featureId,
    params,
  }: {
    token: string;
    featureId: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/features/${featureId}`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}

export class FeaturesRequest implements RequestInterface {
  method = 'get';
  path: string;
  headers: Record<string, any>;
  params?: Record<string, any>;

  constructor({
    token,
    params,
  }: {
    token: string;
    params?: Record<string, any>;
  }) {
    this.path = `/api/v1/features`;
    this.headers = {
      authorization: `Bearer ${token}`,
    };
    if (params) {
      this.params = {
        ...params,
      };
    }
  }
}
